import React, { useState, useContext, createContext } from "react";
var ModalContext = createContext({
  openModal: null,
  closeModal: null,
  isModalOpen: false
});
export default ModalContext;